import { emitter, EVENTS } from '../utils/events'

const useManageScrollHeader = () => {
  const SCROLL_TRESHOLD = 200
  let lastDirection = window.lenis.direction

  const manageHeader = (e) => {
    const currentScrollY = e.scroll

    if (currentScrollY > SCROLL_TRESHOLD) {
      emitter.emit(EVENTS.HEADER.MINIMIZE, { active: true })
      if (e.direction === 1 && lastDirection !== e.direction) {
        // scrolling down
        emitter.emit(EVENTS.HEADER.HIDE, { active: true })
      }
      if (e.direction === -1 && lastDirection !== e.direction) {
        // scrolling down
        emitter.emit(EVENTS.HEADER.HIDE, { active: false })
      }
      lastDirection = e.direction
    } else {
      emitter.emit(EVENTS.HEADER.MINIMIZE, { active: false })
    }
  }

  window.lenis.on('scroll', (e) => manageHeader(e))
}

export default useManageScrollHeader
